import React from 'react';
import { MenuItemVariationPropType } from '../../../../../../services/proptypes';
import ItemVariation from '../ItemVariation';
var defaultProps = {
  precision: 2,
  displayZeroCostItemPrices: false
};
var ItemVariations = function ItemVariations(_ref) {
  var variations = _ref.variations,
    precision = _ref.precision,
    displayZeroCostItemPrices = _ref.displayZeroCostItemPrices;
  var isSingleVariation = variations.length === 1;
  var variationsStyle = {
    display: 'flex',
    flexWrap: 'wrap'
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "item-variations",
    style: variationsStyle
  }, variations.map(function (_ref2, index) {
    var name = _ref2.name,
      price = _ref2.price;
    return /*#__PURE__*/React.createElement(ItemVariation, {
      key: name,
      name: name,
      price: price,
      isOnlyVariation: isSingleVariation,
      isLastVariation: index === variations.length - 1,
      precision: precision,
      displayZeroCostItemPrices: displayZeroCostItemPrices
    });
  }));
};
ItemVariations.defaultProps = defaultProps;
export default ItemVariations;